import {
    Box,
    Button,
    Icon,
    InputAdornment,
    TextField,
    Typography,
} from "@mui/material";
import { SubmitHandler, useForm } from "react-hook-form";
import { toEnglishDigits } from "../../../../utils/language";
import { useTutorialContext } from "../../../tutorialModule/TutorialContext";
import GoogleRecaptcha from "../shared/GoogleRecaptcha";

type TProps = {
    isLoading: boolean;
    sendPhoneNumber: (phoneNumber: string, token: string) => void;
    captchaAction: string;
};

export default function PhoneNumberStep(props: TProps) {
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors, touchedFields },
    } = useForm<{ phoneNumber: string; token: string }>({ mode: "onBlur" });
    const { tutorials } = useTutorialContext();

    const onSubmit: SubmitHandler<{ phoneNumber: string; token: string }> = (
        data
    ) => {
        props.sendPhoneNumber(data.phoneNumber, data.token);
    };

    const setToken = (token: string) => {
        setValue("token", token);
    };

    const handleSendPhoneNumber = () => {
        if (!errors.phoneNumber) {
            handleSubmit(onSubmit)();
        }
    };

    return (
        <>
            <GoogleRecaptcha
                setToken={setToken}
                captchaAction={props.captchaAction}
            />
            <Box>
                <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
                    لطفا شماره موبایل خود را وارد کنید
                </Typography>

                <TextField
                    fullWidth
                    label="شماره موبایل"
                    type="tel"
                    placeholder="شماره موبایل"
                    error={!!touchedFields.phoneNumber && !!errors.phoneNumber}
                    {...register("phoneNumber", {
                        required: true,
                        pattern:
                            /^(?:0[0-9۰-۹]{10}|9[0-9۰-۹]{9}|\+98[0-9۰-۹]{10})$/,
                        onChange(event) {
                            const value = event.target.value;
                            const fixedValue = toEnglishDigits(value);
                            setValue("phoneNumber", fixedValue);
                        },
                    })}
                    helperText={
                        !!touchedFields.phoneNumber && !!errors.phoneNumber
                            ? "شماره موبایل معتبر نیست"
                            : ""
                    }
                    variant="outlined"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Icon>phone</Icon>
                            </InputAdornment>
                        ),
                    }}
                    sx={{ mb: 4 }}
                />

                <Button
                    fullWidth
                    variant="contained"
                    size="large"
                    onClick={handleSendPhoneNumber}
                    disabled={props.isLoading}
                    endIcon={<Icon>arrow_back</Icon>}
                    sx={{ py: 1.5 }}
                >
                    {props.isLoading ? "در حال ارسال..." : "ارسال کد تایید"}
                </Button>
            </Box>
        </>
    );
}
